<template>
  <div class="container">
    <!-- 展示图书列表 -->
    <a-list item-layout="vertical" size="large" :grid="{ gutter: 20, column: 3 }"
      :data-source="data"><!-- 显示分页:pagination="pagination" -->
      <template #renderItem="{ item }">
        <!-- 卡片效果 -->
        <router-link :to="'/doc?ebookId=' + item.id" slots="a" target="_blank">
          <a-card style="height: 180px;margin: 5px;" :bordered="true" :hoverable="true" class="card">
            <a-list-item key="item.title">
              <template #actions>
                <!-- 文章节点数 -->
                <span>
                  <component v-bind:is="'FileOutlined'" style="margin-right: 8px" />
                  {{ item.docCount }}
                </span>
                <!-- 阅读数 -->
                <span>
                  <component v-bind:is="'UserOutlined'" style="margin-right: 8px" />
                  {{ item.viewCount }}
                </span>
                <!-- 点赞数 -->
                <span>
                  <component v-bind:is="'LikeOutlined'" style="margin-right: 8px" />
                  {{ item.voteCount }}
                </span>
              </template>
              <a-list-item-meta> <!--:description="item.description"-->
                <template #title>
                  <router-link :to="'/doc?ebookId=' + item.id" slots="a" target="_blank">
                    {{ item.name }}
                  </router-link>
                </template>
                <template #avatar>
                  <a-avatar :src="item.coverUrl" />
                </template>
                <!-- 图书描述限定2行 -->
                <template #description>
                  <span class="description">
                    {{ item.description }}
                  </span>
                </template>
              </a-list-item-meta>
            </a-list-item>
          </a-card>
        </router-link>
      </template>
    </a-list>
  </div>
</template>

<script lang="ts">
import { defineComponent, defineProps, ref, onMounted, watch } from 'vue'

// 卡片图书组件
export default defineComponent({
  name: 'TheEbooksCard',
  props: {
    // 组件传入的数据
    data: {

    }
  },

  setup(props) {

    // let ebooks: any = ref([]);

    // 监听data变化
    watch(() => props.data, async (newData, oldData) => {
      console.log('watch', newData, oldData)
      // ebooks.value = newData
    })

    onMounted(() => {
      // console.log('data -------' + props.data + '----------')
    });

    return {
      // ebooks
    }
  }
});
</script>
<style scoped>
.container {
  /* background: #F2F4F6;
  padding: 0px; */
}

/*电子书图标形状*/
.ant-avatar {
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 8%;
  margin: 5px 0;
}

/* 限定描述 2行 */
.description {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
